import { AbstractControl } from '@angular/forms';

export class CustomValidators {
    static rfcConHomoclave(control: AbstractControl) {      
      const regex = /^(([ÑA-Z|ña-z|&]{3}|[A-Z|a-z]{4})\d{2}((0[1-9]|1[012])(0[1-9]|1\d|2[0-8])|(0[13456789]|1[012])(29|30)|(0[13578]|1[02])31)(\w{2})([A|a|0-9]{1}))$|^(([ÑA-Z|ña-z|&]{3}|[A-Z|a-z]{4})([02468][048]|[13579][26])0229)(\w{2})([A|a|0-9]{1})$/;
      const found = control.value.match(regex);
      if (control.value.length == 13 && found != null) {
        return null;
      } else {
        return { rfc_invalid: true };
      }      
    }

    static rfcSinHomoclave(control: AbstractControl) {
      const regex = /^(([ÑA-Z|ña-z|&]{3}|[A-Z|a-z]{4})\d{2}((0[1-9]|1[012])(0[1-9]|1\d|2[0-8])|(0[13456789]|1[012])(29|30)|(0[13578]|1[02])31))/;
      const regexlong = /^(([ÑA-Z|ña-z|&]{3}|[A-Z|a-z]{4})\d{2}((0[1-9]|1[012])(0[1-9]|1\d|2[0-8])|(0[13456789]|1[012])(29|30)|(0[13578]|1[02])31)(\w{2})([A|a|0-9]{1}))$|^(([ÑA-Z|ña-z|&]{3}|[A-Z|a-z]{4})([02468][048]|[13579][26])0229)(\w{2})([A|a|0-9]{1})$/;
      const found = control.value.match(regex);
      const foundlong = control.value.match(regexlong);
      if ( (control.value.length == 10 && found != null) || (control.value.length == 13 && foundlong != null) || control.value == '') {
        return null;
      } else {
        return { rfc_invalid: true };
      }        
    }

  }